const footerMixins = {
  data: () => ({
    footerSubjects: [
      {
        title: "Support",
        items: [
          {
            title: "FAQ",
            page: {
              url: "/support/faq",
             
            }
          },
          {
            title: "comment",
            page: {
              isComment: true,
             
            }
          },
          {
            title: "Warranty",
            page: {
              isWarranty: true,
            
            
            }
          },
          {
            title: "Contact Us",
            page: {
              isCU: true,
             
            }
          }
        ]
      },
      {
        title: "Explore",
        items: [
          {
            title: "Buy on Amazon",
            page: {
              url: "https://www.amazon.com/1byone",
              isLink: true
            }
          },
          {
            title: "Look for products",
            page: {
              url: "/search?c=health"
            }
          }
        ]
      },
      {
        title: "Privacy",
        items: [
          {
            title: "Terms of Use",
            page: {
              url: "/support/terms_condition"
            }
          },
          {
            title: "Privacy Policy",
            page: {
              url: "/support/privacy_policy"
            }
          }
        ]
      }
    ],
    socialMedias: [
      {
        type: "Facebook",
        image: "facebook.png",
        url: "//facebook.com/1byonehealth/",
        cssClass: "social-media-facebook"
      },
      {
        type: "Instagram",
        image: "instagram.png",
        url: "//instagram.com/1byone_official/",
        cssClass: "social-media-instagram"
      },
      {
        type: "YouTube",
        image: "youtube.png",
        url: "//youtube.com/user/1BYONEDOORBELLS",
        cssClass: "social-media-youtube"
      },
      {
        type: "twitter",
        image: "twitter.png",
        url: "//twitter.com/The_1ByOne",
        cssClass: "social-media-twitter"
      }
    ]
  }),
  computed: {
    copyRightStatement() {
      let currentYear = new Date().getFullYear();
      return `Copyright © ${currentYear} 1byone, Inc. All rights reserved`;
    }
  }
};

export default footerMixins;
